/* Bundle Compare (MVP): builds a simple carousel modal from current bundle selections */
(function(){
  const SELECTOR_ROOT = '[data-bundle-root]';
  const TRIGGER = '.js-open-bundle-compare';
  const MODAL = '#bundle-compare-modal';

  function $q(root, sel){ return (root||document).querySelector(sel); }
  function $$q(root, sel){ return Array.from((root||document).querySelectorAll(sel)); }

  function formatMoney(cents){
    if(window.formatMoney){ return window.formatMoney(cents, window.shopMoneyFormat || undefined); }
    const currency = window?.Shopify?.currency?.active || 'USD';
    return (cents/100).toLocaleString(undefined,{ style:'currency', currency });
  }

  function collectStepProducts(root, stepIndex){
    // Return ALL products available in a step's grid (not just selected)
    const products = [];
    const steps = $$q(root, '[data-step-id]');
    const stepEl = steps[stepIndex || 0];
    if(!stepEl) return products;
    const grid = stepEl.querySelector('.bundle-step-products__grid');
    if(!grid) return products;
    $$q(grid, '.bundle-product-card').forEach(li => {
      if(li.hidden) return; // respect conditional filtering
      const id = li.getAttribute('data-product-id');
      const title = li.querySelector('.bundle-product-card__title')?.textContent?.trim();
      const img = li.querySelector('.bundle-product-card__media img')?.getAttribute('src') || '';
      const priceEl = li.querySelector('[data-price]');
      const price = priceEl ? priceEl.textContent.trim() : '';
  let specs = [];
  const raw = li.getAttribute('data-compare-fields');
      if(raw){
        try{
          const parsed = JSON.parse(raw);
          if(Array.isArray(parsed)) specs = parsed.filter(r=>r && typeof r.key==='string');
        }catch(e){ specs = []; }
      }
      if(specs.length === 0){
        // Try extracting from single metaobject raw payload
        const rawObjStr = li.getAttribute('data-compare-raw');
        if(rawObjStr){
          try{
            const obj = JSON.parse(rawObjStr);
            // Generic fallback: if obj.fields exists
            if(obj && Array.isArray(obj.fields) && obj.fields.length){
              specs = obj.fields.map(f=>({ key: String(f.key||'').trim(), value: f.value })).filter(r=>r.key);
            } else if(obj && typeof obj === 'object'){
              // Try common handle pairs
              const pairs = [];
              const possible = [
                ['label','value'],
                ['name','value'],
                ['key','value'],
                ['title','text']
              ];
              possible.forEach(([k,v])=>{
                if(obj[k]) pairs.push({ key: String(obj[k]), value: obj[v]||'' });
              });
              if(pairs.length) specs = pairs;
            }
          }catch(e){ /* ignore */ }
        }
      }
      if(!Array.isArray(specs)) specs = [];
      if(id && title){ products.push({ id, title, image: img, price, specs }); }
    });
    return products;
  }

  function buildCard(p){
    const d = document.createElement('div');
    d.className = 'bundle-compare__card';
    const img = p.image ? `<img class="bundle-compare__image" src="${p.image}" alt="">` : '';
    const price = p.price ? `<div class="bundle-compare__price">${p.price}</div>` : '';
    d.innerHTML = `${img}<div class="bundle-compare__name" title="${p.title}">${p.title}</div><div class="bundle-compare__spec"></div>`;
    return d;
  }

  function buildHeaders(_products, _opener){
    // Hardcoded list aligned with compare-product-card.liquid
    // and the user's requested fields (shared with compare section).
    return [
      'patented_high_security_lock_system',
      'usps_approved_curbside_full_service_mailbox',
      'material',
      'mail_access_type',
      'incoming_mail_capacity',
      'patented_fast_trak_mounting_plate',
      'rust_resistance',
      'max_incoming_package_size',
      'maximum_mail_packaging_dimensions',
      'outgoing_mail_capacity',
    ];
  }

  function buildHeadingRow(products){
    const row = document.createElement('div');
    row.className = 'bundle-compare__spec-row bundle-compare__spec-row--heading';
    products.forEach(p => {
      const cell = document.createElement('div');
      cell.className = 'bundle-compare__spec-value bundle-compare__spec-value--heading';
      const imgHtml = p.image ? `<img class="bundle-compare__image" src="${p.image}" alt="">` : '';
      const titleHtml = p.title ? `<div class="bundle-compare__name" title="${p.title}">${p.title}</div>` : '';
      const priceHtml = p.price ? `<div class="bundle-compare__price">${p.price}</div>` : '';
      cell.innerHTML = `${imgHtml}${titleHtml}${priceHtml}`;
      row.appendChild(cell);
    });
    return row;
  }

  function updateArrows(viewport, prevBtn, nextBtn){
    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
    prevBtn.disabled = viewport.scrollLeft <= 1 || maxScroll === 0;
    nextBtn.disabled = viewport.scrollLeft >= maxScroll || maxScroll === 0;
  }

  function openModal(opener){
    const modal = $q(document, MODAL);
    if(!modal) return;
    const root = opener.closest(SELECTOR_ROOT) || document;
    const stepIndex = parseInt(opener.getAttribute('data-bc-step-index')||'0',10) || 0;
    const track = $q(modal, '[data-bc-track]');
    const countEl = $q(modal, '[data-bc-count]');
    const viewport = $q(modal, '[data-bc-viewport]');
    const prevBtn = $q(modal, '[data-bc-prev]');
    const nextBtn = $q(modal, '[data-bc-next]');

    track.innerHTML = '';
    const products = collectStepProducts(root, stepIndex);
    if(countEl) countEl.textContent = products.length;
    if(!products.length) return;

    const headers = buildHeaders(products, opener);

    // Build shared spec table like compare-section.js
    const tableEl = document.createElement('div');
    tableEl.className = 'bundle-compare__spec-table';
    tableEl.appendChild(buildHeadingRow(products));

    headers.forEach(h => {
      // Skip blocks where every product is empty for this header
      const allEmpty = products.every(p => {
        const map = new Map((p.specs||[]).map(s=>[String(s.key||'').trim(), s.value]));
        const v = map.get(h);
        return v === undefined || v === null || String(v).trim() === '';
      });
      if(allEmpty) return;

      const row = document.createElement('div');
      row.className = 'bundle-compare__spec-row';

      products.forEach(p => {
        const specMap = new Map((p.specs||[]).map(s=>[String(s.key||'').trim(), s]));
        const cell = document.createElement('div');
        cell.className = 'bundle-compare__spec-pair';
        const labelEl = document.createElement('div');
        labelEl.className = 'bundle-compare__spec-label';
        let labelText = '';
        const specForThisProduct = specMap.get(h);
        if(specForThisProduct && specForThisProduct.label){
          labelText = specForThisProduct.label;
        }else{
          const fromAnyProduct = products
            .map(prod => (prod.specs||[]).find(s => String(s.key||'').trim() === h && s.label))
            .find(Boolean);
          labelText = (fromAnyProduct && fromAnyProduct.label) || h;
        }
        labelEl.textContent = labelText;
        const valueEl = document.createElement('div');
        valueEl.className = 'bundle-compare__spec-value';
        let rawVal = '';
        if(specForThisProduct){ rawVal = specForThisProduct.value || ''; }

        // Boolean handling: render check/minus icons for true/false values (match compare-section.js)
        if(typeof rawVal === 'boolean' || rawVal === 'true' || rawVal === 'false'){
          const isTrue = rawVal === true || rawVal === 'true';
          const rootPath = window.Shopify?.routes?.root || '/';
          const iconUrl = isTrue ? 'https://mailboss.myshopify.com/cdn/shop/t/3/assets/icon-check.svg?v=121642116301063243251764889208' : 'https://mailboss.myshopify.com/cdn/shop/t/3/assets/icon-minus.svg?v=121642116301063243251764889208';
          valueEl.innerHTML = `<span class="compare-boolean compare-boolean--${isTrue ? 'true' : 'false'}"><img src="${iconUrl}" alt="${isTrue ? 'Yes' : 'No'}" loading="lazy"></span>`;
        }else if(typeof rawVal === 'string' && rawVal.indexOf('<') !== -1){
          valueEl.innerHTML = rawVal;
        }else{
          valueEl.textContent = rawVal;
        }
        cell.appendChild(labelEl);
        cell.appendChild(valueEl);
        row.appendChild(cell);
      });

      tableEl.appendChild(row);
    });

    const wrapper = document.createElement('div');
    wrapper.className = 'bundle-compare__spec';
    wrapper.appendChild(tableEl);
    track.appendChild(wrapper);

    // Show modal (uses modal-dialog web component defined in modal.js)
  if(typeof modal.open === 'function'){ modal.open(opener); } else { modal.setAttribute('open',''); }

    // Scroll snap behavior
    const card = track.querySelector('.bundle-compare__card');
    const styleGap = parseInt(getComputedStyle(track).gap || '16', 10);
    const cardWidth = card ? (card.getBoundingClientRect().width + styleGap) : 280;
    const scrollByCard = (dir)=> viewport.scrollBy({ left: dir * cardWidth, behavior:'smooth' });

    const onScroll = ()=> updateArrows(viewport, prevBtn, nextBtn);
    viewport.removeEventListener('scroll', onScroll);
    viewport.addEventListener('scroll', onScroll, { passive:true });

    prevBtn.onclick = ()=> scrollByCard(-1);
    nextBtn.onclick = ()=> scrollByCard(1);
  // Initial state and on resize/content load
  const refresh = ()=> updateArrows(viewport, prevBtn, nextBtn);
  setTimeout(refresh, 50);
  window.addEventListener('resize', refresh, { passive:true });
  const ro = new ResizeObserver(refresh);
  ro.observe(track);
  // Clean up on modal close
  const cleanup = () => { window.removeEventListener('resize', refresh); try{ ro.disconnect(); }catch(e){} };
  modal.addEventListener('keyup', (e)=>{ if(e.key==='Escape') cleanup(); }, { once:true });
  }

  function bindTriggers(){
    $$q(document, SELECTOR_ROOT).forEach(root => {
      const trigger = root.querySelector(TRIGGER);
      if(!trigger) return;
      let scheduled = false;
      const enableOrDisable = () => {
        if(scheduled){ return; }
        scheduled = true;
        requestAnimationFrame(()=>{
          scheduled = false;
          // Enable when configured step has at least 2 products available to compare
          const stepIndex = parseInt(trigger.getAttribute('data-bc-step-index')||'0',10) || 0;
          const steps = root.querySelectorAll('[data-step-id]');
          const stepEl = steps[stepIndex];
          const gridCards = stepEl ? stepEl.querySelectorAll('.bundle-step-products__grid .bundle-product-card:not([hidden])') : [];
          const enabled = gridCards && gridCards.length >= 2;
        trigger.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        trigger.classList.toggle('is-disabled', !enabled);
        });
      };
      enableOrDisable();
      root.addEventListener('bundle:readyToBuild', enableOrDisable);
      const observer = new MutationObserver(enableOrDisable);
      const watch = root.querySelector('[data-steps]') || root;
      observer.observe(watch, { childList: true, subtree: true });
      trigger.addEventListener('click', (e)=>{
        if(trigger.getAttribute('aria-disabled') === 'true'){ e.preventDefault(); return; }
        openModal(trigger);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindTriggers);
})();
